import { Component, OnInit } from '@angular/core';
import { INavData } from '@coreui/angular';
import { Observable } from 'rxjs';
import { TogglerService } from '../../_infrastructure/classes/services/toggler.service';
import { NavMenuService } from './navmenu.service';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './navmenu.component.html',
})
export class NavMenuComponent implements OnInit {
    public sidebarMinimized = true;

    constructor(
        public navMenuService: NavMenuService,
        private togglerService: TogglerService,
    ) {}

    onVisibleChange($event: any): void {
        this.togglerService.setSidebarVisibility($event);
    }

    ngOnInit() {
        this.togglerService.minimizer$.subscribe(() => {
            this.sidebarMinimized = !this.sidebarMinimized;
        });
    }

    public getItems(): Observable<INavData[]> {
        return this.navMenuService.items$;
    }
}
